import React from 'react';
import { NavLink } from 'react-router-dom';

const videoSrc = require('./../../images/video_main.mp4');

class Slider extends React.Component {
    constructor(props) {
        super(props);
        this.paragraphRef = React.createRef();
    }

    componentDidMount() {
        const paragraph = this.paragraphRef.current;
        if (!paragraph) return;

        function textEffect(animationName) {
            var text = paragraph.innerHTML,
                chars = text.length,
                newText = '',
                animation = animationName,
                i;

            for (i = 0; i < chars; i += 1) {
                newText += '<i>' + text.charAt(i) + '</i>';
            }

            paragraph.innerHTML = newText;

            var wrappedChars = document.getElementsByTagName('i'),
                wrappedCharsLen = wrappedChars.length,
                j = 0;

            function addEffect() {
                setTimeout(function () {
                    wrappedChars[j].className = animation;
                    j += 1;
                    if (j < wrappedCharsLen) {
                        addEffect();
                    }
                }, 100);
            }

            addEffect();
        }

        textEffect('fly-in-out');
    }

    render() {
        return (
            <section className="hero-video-section">
                <video className="hero-video-section__bg" autoPlay muted loop playsInline>
                    <source src={videoSrc} type="video/mp4" />
                </video>
                <div className="hero-video-section__overlay" />
                <div className="hero-video-section__content">
                    <div className="hero-video-section__copy ">
                        <h1 className="hero-video-section__title">
                            <div className="message text">
                                <div className="word1">Crafting Your Legacy Today</div>
                                <div className="word2">Quality You Can Trust In</div>
                                <div className="word3">Building The Future Together</div>
                            </div>
                        </h1>
                        <p ref={this.paragraphRef} className="hero-video-section__description">
                            Where imagination meets expert craftsmanship, we turn blueprints into breathtaking structures.
                        </p>
                        <NavLink to="/about" className="hero-video-section__button site-button-secondry btn-effect">
                            More About
                        </NavLink>
                        {/* <NavLink to="/contactus" className="site-button-secondry btn-effect bg-dark">More About</NavLink> */}
                    </div>
                </div>
            </section>
        );
    }
}

export default Slider;
